import { Component } from '@angular/core';
import { ViewController, NavParams, NavController } from "ionic-angular";
import { DomSanitizer } from '@angular/platform-browser';
import { StorageService } from '../../providers/storage.service';
@Component({
  selector: "page-browser",
  templateUrl: 'browser.html'
})
export class BrowserPage {

  title: string;
  secUrl: any;

  constructor(
    public navCtrl: NavController,
    private params: NavParams,
    private sanitizer: DomSanitizer,
    private viewCtrl: ViewController,
    private storage: StorageService,
  ) {
    this.title = "在线挂机";

    let bb = this.storage.readString('AfkURL');
    if (bb) {
      this.secUrl =  this.sanitizer.bypassSecurityTrustResourceUrl(bb);
    }
  }

  /**
   * ionic中当页面进入初始化的时候触发的生命周期方法 --- 当进入挂机时，关闭平台的tab 菜单，显示挂机tab 菜单
   */
  ionViewDidEnter() {
    let elements = document.querySelectorAll(".tabbar");
    if (elements != null) {
      Object.keys(elements).map((key) => {
        elements[key].style.display = 'none';
      });
    }

  }

  //ionic当退出页面的时候触发的方法 ---- 当退出挂机时，显示平台tab 菜单
  ionViewWillLeave() {
    let elements = document.querySelectorAll(".tabbar");
    if (elements != null) {
      Object.keys(elements).map((key) => {
        elements[key].style.display = 'flex';
      });
    }
  }

  dismiss() {
    if (!this.params.get("url")) {
      this.navCtrl.parent.select(0);
    } else {
      this.viewCtrl.dismiss();
    }
  }
}


// WEBPACK FOOTER //
// ./src/pages/browser/browser.ts